import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import HouseholdForm from '../../../libs/gs-component-add-guest';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import GuestListStore from '~/glm/models/guest-list-store';
import AnalyticsStore from '~/glm/models/analytics-store';

@inject('gdsUiState', 'guestListStore', 'analyticsStore')
@observer
class EditHousehold extends React.Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore),
  };

  close = () => {
    const { gdsUiState } = this.props;
    gdsUiState.setShowHouseholdForm(false);
    gdsUiState.setEditingHousehold(null);
    gdsUiState.setHouseholdFormDefaultState('main');
  };

  onSuccess = data => {
    const { guestListStore } = this.props;
    guestListStore.addGdsHousehold(data);
  };

  onDelete = id => {
    const { guestListStore } = this.props;
    guestListStore.households.remove({ id });
  };

  render() {
    const { gdsUiState, guestListStore, analyticsStore } = this.props;
    const { guestWedding } = guestListStore;

    let household;
    // If we have a household to edit
    if (gdsUiState.editingHousehold) {
      // Transform the household to a form the HouseholdForm expects
      const { street1, street2, city, state, zip, country, fullAddress } = gdsUiState.editingHousehold;
      const { id, description, rsvpNote, coupleNote, members, answers } = gdsUiState.editingHousehold;
      household = {
        id,
        description,
        rsvpNote,
        coupleNote,
        address: { street1, street2, city, state, zip, country, fullAddress },
        answers: answers ? answers.peek() : null,
        people: members.map(m => {
          const { id, isLeader, firstName, lastName, phone, email, invitations } = m;
          return {
            id,
            isLeader,
            firstName,
            lastName,
            phone,
            email,
            invitations: invitations.map(i => {
              const { id, eventId, invitationSent, rsvp, meal, gift, answers, thankYouSent } = i;
              return {
                id,
                eventId,
                invitationSent,
                rsvp,
                meal,
                gift,
                thankYouSent,
                answers: answers.map(a => {
                  const { questionId, optionId, text } = a;
                  return {
                    questionId,
                    optionId,
                    text,
                  };
                }),
              };
            }),
          };
        }),
      };
    }
    // Otherwise nothing is passed as the household, indicating the intent is to add a household
    return (
      <HouseholdForm
        isOpen={gdsUiState.showHouseholdForm}
        onClose={this.close}
        onSuccess={this.onSuccess}
        onDelete={this.onDelete}
        household={household}
        events={guestListStore.gdsEvents}
        wedding={guestListStore.guestWedding}
        selectedEvent={gdsUiState.selectedEvent}
        guestWeddingQuestions={guestWedding.questions}
        defaultView={gdsUiState.householdFormDefaultState}
        analyticsObject={{
          ...analyticsStore.baseTrackingParams,
          ...analyticsStore.selectedEventParams,
        }}
      />
    );
  }
}

export default EditHousehold;
